module.exports = __webpack_public_path__ + "fonts/GenSenRounded-B.75c2ebbc.woff2";